import { createSlice } from '@reduxjs/toolkit';

type HtmlElementState = {
    anchorEl: HTMLElement | null;
    arrowRef: HTMLElement | null;
};

const initialState: HtmlElementState = {
    anchorEl: null,
    arrowRef: null,
};

export const HtmlElementsSlice = createSlice({
    name: 'htmlElement',
    initialState,
    reducers: {
        changeAnchorEl: (state, { payload }) => {
            state.anchorEl = payload;
        },
        changeArrowRef: (state, { payload }) => {
            state.arrowRef = payload;
        },
        handleClickInfoBlacklist: (state, { payload }) => {
            if (state.anchorEl) {
                state.anchorEl = null;
            } else {
                state.anchorEl = payload.target;
            }
        },
    },
});

export const open = (state: HtmlElementState) => {
    return Boolean(state.anchorEl);
};

export const { changeAnchorEl, changeArrowRef, handleClickInfoBlacklist } =
    HtmlElementsSlice.actions;

export default HtmlElementsSlice.reducer;
